






















































































































import { Component, Vue } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import PackingPlanBaseForm from './packing-plan-base-form.vue'
import PackingPlanExtraForm from './packing-plan-extra-form.vue'
import PackingDetailForm from './packing-detail-form.vue'
import PrintWaybillForm from './print-pack-from.vue';
import appconst from '@/lib/appconst';
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import DateUtils from '@/common/js/DateUtils'
import moment from 'moment'

interface SelectOption {
    value: boolean | null;
    label: string;
}

class PackingBatchSearchRequest extends PageRequest {
    userId?: number; // 新增用户ID
    startDate?: Date;
    endDate?: Date;
    boxBatchNumber: string = '';
    shippingMark: string = '';
    trackingNumber: string = '';
    storeId?: number | null;
    isProcessed?: boolean | null;
    isSelf?: boolean | null = false; // 默认自装箱为否
}

interface PackingBatchListItem {
    id: number;
    boxBatchNumber: string;
    shippingMark: string;
    trackingNumber: string;
    storeId: number;
    storeName: string;
    creationTime: Date;
    isSelf: boolean;
    isProcessed: boolean;
    remark: string;
    inStockList: any[];
    packingDetailList: any[];
}

@Component({
    name: "backpackingbatchmanager",
    components: { PackingPlanBaseForm, PackingPlanExtraForm, PackingDetailForm, PrintWaybillForm }
})
export default class BackPackingBatchManager extends AbpBase {
    baseModalShow: boolean = false;
    extraModalShow: boolean = false;
    detailModalShow: boolean = false;
    currentPackingPlanId: number = 0;
    currentPackingDetailList: any[] = [];
    currentProductIds: number[] = [];
    printModalShow: boolean = false;
    currentRowData: any = null;

    storeaddressList: Array<storeaddressInfo> = [];
    pagerequest: PackingBatchSearchRequest = new PackingBatchSearchRequest();
    creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];

    IsSelfOptions: SelectOption[] = [
        { value: null, label: '全部' },
        { value: true, label: '是' },
        { value: false, label: '否' }
    ];
    IsProcessedOptions: SelectOption[] = [
        { value: null, label: '全部' },
        { value: true, label: '是' },
        { value: false, label: '否' }
    ];


    // ================= 新增：导入相关属性 =================
    importModalShow: boolean = false;
    importLoading: boolean = true;
    importExcelUrl: string = ''; // 请根据实际接口地址修改
    importUploadData: any = {};

    // 添加 headers 配置
    headers: any = {
        "Authorization": "Bearer " + window.abp.auth.getToken(),
        ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
        "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
    };


    // ================= 新增：导入前校验 =================
    beforeImportUpload(file: any) {
        const isValidType = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
        if (!isValidType) {
            this.$Message.error('请上传Excel文件（.xlsx或.xls格式）');
            return false;
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            this.$Message.error('文件大小不能超过10MB');
            return false;
        }
        return true;
    }

    // ================= 新增：导入成功回调 =================
    handleImportSuccess(res: any, file: any, fileList: any) {
        if (res && res.success) {
            this.$Message.success('导入成功！');
            this.importModalShow = false;
            this.getpage(); // 刷新列表
        } else {
            this.$Message.error(res.message || '导入失败');
        }
        // 关闭弹窗loading
        this.importLoading = false;
        setTimeout(() => {
            this.importLoading = true;
        }, 500);
    }

    // ================= 新增：获取错误信息工具方法 =================
    getErrorMessage(error: any): string {
        if (error && error.error.message) {
            return error.error.message;
        }
        return '导入失败，请检查网络或联系管理员';
    }

    // ================= 新增：导入失败回调 =================
    handleImportError(error, file, fileList) {
        const errorMsg = this.getErrorMessage(file);
        this.$Message.error(errorMsg);
        this.importLoading = false;
        setTimeout(() => {
            this.importLoading = true;
        }, 500);
    }
    // ================= 新增：取消导入 =================
    cancelImport() {
        this.importModalShow = false;
    }
    // ================= 新增：下载导入模板 =================
    downloadTemplate() {
        // 模板下载地址，请根据实际配置修改
        const templateUrl = window.location.origin + "/template/装箱模板.xlsx";
        window.open(templateUrl);
    }

    // 打开上传模态框
    uploadDetail(data: any) {
        this.importModalShow = true;
        this.importExcelUrl = appconst.remoteServiceBaseUrl + "api/services/app/PrePlan/UploadPackDetail?packingPlanId=" + data.id + "&userId=" + abp.session.userId;
    }

    // 上传前校验
    beforeUpload(file: any) {
        return true;
    }
    //----导入添加

    // ======== 切换到 backPackingBatch ========
    get list(): PackingBatchListItem[] {
        return this.$store.state.backPackingBatch.list;
    }
    get loading(): boolean {
        return this.$store.state.backPackingBatch.loading;
    }
    get pageSize(): number {
        return this.$store.state.backPackingBatch.pageSize;
    }
    get totalCount(): number {
        return this.$store.state.backPackingBatch.totalCount;
    }
    get currentPage(): number {
        return this.$store.state.backPackingBatch.currentPage;
    }

    columns = [
        {
            title: '基本信息',
            width: 250,
            fixed: 'left',
            render: (h: any, params: any) => {
                const row = params.row;
                return h('div', [
                    h('h3', `装箱批次号：${row.boxBatchNumber || ''}`),
                    h('h3', `仓库名称：${row.storeName || ''}`),
                    h('h3', `是否自装箱：${row.isSelf ? '是' : '否'}`),
                    h('h3', `是否已处理：${row.isProcessed ? '是' : '否'}`),
                    h('h3', `创建时间：${DateUtils.formatLongDate(new Date(row.creationTime))}`)
                ]);
            }
        },
        {
            title: '装箱信息',
            width: 200,
            render: (h: any, params: any) => {
                const row = params.row;
                return h('div', [
                    h('h3', `唛头：${row.shippingMark || ''}`),
                    h('h3', `运单号：${row.trackingNumber || ''}`),
                    h('h3', `备注：${row.remark || '无'}`)
                ]);
            }
        },
        {
            title: '装箱记录',
            width: 520,
            render: (h: any, params: any) => {
                const row = params.row;
                const packingList = row.packingDetailList || [];
                if (packingList.length === 0) {
                    return h('span', '暂无装箱记录');
                }
                const packingHeader = ['箱号', '产品ID', '用户ID', '装箱数量', '装箱时间'];
                return h('div', { style: { overflow: 'auto' } }, [
                    h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px' } }, [
                        h('thead', [
                            h('tr', { style: { background: '#f5f5f5' } },
                                packingHeader.map((header, idx) => {
                                    let thStyle: any = { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', whiteSpace: 'nowrap' };
                                    switch (idx) {
                                        case 0: thStyle.width = '50px'; break;
                                        case 1: thStyle.width = '80px'; break;
                                        case 2: thStyle.width = '80px'; break;
                                        case 3: thStyle.width = '80px'; break;
                                        case 4: thStyle.width = '180px'; break;
                                        default: thStyle.width = '100px'; break;
                                    }
                                    return h('th', { key: idx, style: thStyle }, header);
                                })
                            )
                        ]),
                        h('tbody',
                            packingList.map((packing: any, index: number) => {
                                const boxNum = packing.boxNumber || 0;
                                const productId = packing.productId || 0;
                                const userId = packing.userId || 0;
                                const productNums = packing.productNums || 0;
                                const createTime = packing.creationTime
                                    ? DateUtils.formatLongDate(new Date(packing.creationTime))
                                    : '';
                                return h('tr', { key: index }, [
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, boxNum),
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, productId),
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, userId),
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, productNums),
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, createTime)
                                ]);
                            })
                        )
                    ])
                ]);
            }
        },
        {
            title: '入库单记录',
            width: 600,
            render: (h: any, params: any) => {
                const row = params.row;
                const stockList = row.inStockList || [];
                if (stockList.length === 0) {
                    return h('span', '暂无入库单记录');
                }
                const tableHeader = ['计划批次', '产品内码', '产品数量', '装箱数量', '状态'];
                return h('div', { style: { overflow: 'auto' } }, [
                    h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px' } }, [
                        h('thead', [
                            h('tr', { style: { background: '#f5f5f5' } },
                                tableHeader.map((header, idx) => {
                                    let thStyle: any = { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', whiteSpace: 'nowrap' };
                                    switch (idx) {
                                        case 0: thStyle.width = '200px'; break;
                                        case 2: thStyle.width = '80px'; break;
                                        case 3: thStyle.width = '80px'; break;
                                        default: thStyle.width = '100px'; break;
                                    }
                                    return h('th', { key: idx, style: thStyle }, header);
                                })
                            )
                        ]),
                        h('tbody',
                            stockList.map((stock: any, index: number) => {
                                const statusText = this.ProductStatus.find(item => item.value === stock.productStatus).name || '';
                                const productNums = Number(stock.productNums) || 0;
                                const boxNumber = Number(stock.boxNumber) || 0;
                                const isNumsMismatch = productNums !== boxNumber;
                                const boxNumberTdStyle = {
                                    border: '1px solid #eee',
                                    padding: '8px 5px',
                                    textAlign: 'center',
                                    color: isNumsMismatch ? 'red' : 'inherit',
                                    fontWeight: isNumsMismatch ? 'bold' : 'normal'
                                };
                                return h('tr', { key: index }, [
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.planNumber || ''),
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.productId || ''),
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, `${productNums}`),
                                    h('td', { style: boxNumberTdStyle }, `${boxNumber}`),
                                    h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, statusText)
                                ]);
                            })
                        )
                    ])
                ]);
            }
        },
        {
            title: '操作',
            width: 200,
            fixed: 'right',
            render: (h: any, params: any) => {
                const row = params.row;
                // 如果是自装箱，不显示任何按钮
                if (row.isSelf) {
                    return h('span', '');
                }
                return h('div', [
                    h('Button', {
                        props: { type: 'primary', size: 'small', icon: 'ios-create' },
                        style: { marginRight: '5px', marginTop: '5px', width: '150px' },
                        on: { click: () => this.modifyBaseInfo(row) }
                    }, "编辑计划批次"),
                    h('Button', {
                        props: { type: 'warning', size: 'small', icon: 'ios-paper' },
                        style: { marginRight: '5px', marginTop: '5px', width: '150px' },
                        on: { click: () => this.modifyExtraInfo(row) }
                    }, "编辑基础信息"),
                    h('Button', {
                        props: { type: 'info', size: 'small', icon: 'ios-list' },
                        style: { marginRight: '5px', marginTop: '5px', width: '150px' },
                        on: { click: () => this.modifyDetail(row) }
                    }, "编辑装箱详情"),
                    h('Button', {
                        props: { type: 'info', size: 'small', icon: 'ios-list' },
                        style: { marginRight: '5px', marginTop: '5px', width: '150px' },
                        on: { click: () => this.uploadDetail(row) }
                    }, "导入装箱详情"),
                    h('Button', {
                        props: { type: 'success', size: 'small', icon: 'ios-checkmark' },
                        style: { marginRight: '5px', marginTop: '5px', width: '150px', display: row.isProcessed ? 'none' : 'inline-block' },
                        on: { click: () => this.markProcessed(row.id) }
                    }, "标记已处理"),
                    h('Button', {
                        props: { type: 'info', size: 'small', icon: 'ios-print' },
                        style: { marginTop: '5px', width: '150px', background: '#48b0f7', borderColor: '#48b0f7' },
                        on: { click: () => this.handlePrintWaybill(row) }
                    }, "打印面单"),
                    h('Button', {
                        props: { type: 'error', size: 'small', icon: 'ios-trash' },
                        style: { marginTop: '5px', width: '150px' },
                        on: { click: () => this.deletePack(row.id) }
                    }, "删除")
                ]);
            }
        }
    ];

    get ProductStatus() {
        return Enums.getEnum(Enums.ProductStatus, true);
    }

    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        });
        const allStoreOption: storeaddressInfo = { id: null, storeName: "全部" } as storeaddressInfo;
        this.storeaddressList = [allStoreOption, ...this.$store.state.backstoreaddress.list];
    }

    add() {
        this.$store.commit('backPackingBatch/setPackingModel', { id: 0 });
        this.baseModalShow = true;
    }

    handlePrintWaybill(row: any) {
        const shippingMark = row.shippingMark;
        if (!shippingMark || shippingMark.trim() === '') {
            this.$Message.warning('请先填写唛头信息，否则无法打印！');
            return;
        }
        this.currentRowData = row;
        this.printModalShow = true;
    }

    modifyBaseInfo(row: any) {
        this.$store.commit('backPackingBatch/setPackingModel', row);
        this.baseModalShow = true;
    }

    modifyExtraInfo(row: any) {
        this.$store.commit('backPackingBatch/setPackingModel', row);
        this.extraModalShow = true;
    }

    modifyDetail(row: any) {
        this.currentPackingPlanId = row.id;
        this.currentPackingDetailList = row.packingDetailList || [];
        this.currentProductIds = [];
        const stockList = row.inStockList || [];
        stockList.forEach((stock: any) => {
            const productId = Number(stock.productId);
            if (productId > 0 && !isNaN(productId) && !this.currentProductIds.includes(productId)) {
                this.currentProductIds.push(productId);
            }
        });
        this.detailModalShow = true;
    }

    async markProcessed(id: number) {
        this.$Modal.confirm({
            title: "标记确认",
            content: "确定要标记该装箱计划为已处理吗？",
            onOk: async () => {
                await this.$store.dispatch({
                    type: 'backPackingBatch/processPack',
                    data: { id }
                });
                this.$Message.success("标记成功！");
                this.getpage();
            }
        });
    }

    async deletePack(id: number) {
        this.$Modal.confirm({
            title: "删除确认",
            content: "确定要删除该装箱计划吗？删除后不可恢复！",
            onOk: async () => {
                await this.$store.dispatch({
                    type: 'backPackingBatch/deletePackPlan',
                    data: { id }
                });
                this.$Message.success("删除成功！");
                this.getpage();
            }
        });
    }

    pageChange(page: number) {
        this.$store.commit('backPackingBatch/setCurrentPage', page);
        this.getpage();
    }

    pagesizeChange(pagesize: number) {
        this.$store.commit('backPackingBatch/setPageSize', pagesize);
        this.getpage();
    }

    async searchPage() {
        this.$store.commit('backPackingBatch/setCurrentPage', 1);
        this.getpage();
    }

    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        if (this.creationTime.length > 0) {
            this.pagerequest.startDate = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endDate = this.creationTime[1];
        }
        await this.$store.dispatch({
            type: 'backPackingBatch/getPackingBatchList',
            data: this.pagerequest
        });
    }

    async created() {
        await this.getData();
        this.getpage();
    }
}
